angular
  .module("personalDocumentsTable.components", ["app.services"])
  .component("personalDocumentsTable", {
    templateUrl: "ng/components/personalDocumentsTable/personalDocumentsTable.view.html",
    controllerAs: "PersonalDocumentsTable",
    bindings: {},
    controller: function personalDocumentsTableCtrl(
      $instantLeasingService,
      $configService,
      $transactionFactory,
      $location,
      InstantModel
    ) {
      var self = this;

      self.$onInit = function () {
        console.log("initializing personalDocumentsTable..");
        self.loader = [];
        //albaInit();

        self.goToPersonalDocuments();
      };

      self.goToPersonalDocuments = function () {
        self.loading = true;
        $instantLeasingService
          .getPersonalActivitiesIl($configService.getUser().identifier)
          .then(function (response) {
            self.itemsList = response.itemsList;
            console.log("La risposta della chiamata: ", response);
          })
          .catch(function (err) {
            console.log("La chiamata è andata in errore: ", err);
          })
          .finally(function () {
            self.loading = false;
          });
      };

      self.goToAddInfoAndDocument = function (item, index) {
        self.loader[index] = true;
        $instantLeasingService.resumeInstance(item.idWfInstance)
          .then(function (response) {
            console.log('La risposta della chiamata: ', response);
            response.appIlTransaction.id = item.id;
            response.idWfInstance = item.idWfInstance;
            response.viewIndex = 5;
            $transactionFactory.set(InstantModel.build(response));
            $location.path("/dataCompletition");

          })
          .catch(function (err) {
            console.log('La chiamata è andata in errore: ', err);
          })
          .finally(function () {
            self.loader[index] = false;
          })
      }

      self.goToPracticeDetail = function (idWfInstance, index) {
        self.loader[index] = true;
        $instantLeasingService.getPracticeDetail(idWfInstance)
          .then(function (response) {
            console.log('La risposta della chiamata: ', response);
            response.idWfInstance = idWfInstance;
            $transactionFactory.set(InstantModel.build(response));
            $location.path("/practiceDetail");

          })
          .catch(function (err) {
            console.log('La chiamata è andata in errore: ', err);
          })
          .finally(function () {
            self.loader[index] = true;
          })

      }
    }
  });